import { Loader2 } from 'lucide-react';
import { Button } from '../../../components/ui/button';
import { SAVE_BAR_COPY } from './constants';
import styles from './SaveBar.module.css';

type SaveState = 'saved' | 'dirty' | 'saving';

interface SaveBarProps {
  isDirty: boolean;
  isSaving: boolean;
  onCancel: () => void;
}

const saveStateOf = ({ isDirty, isSaving }: Pick<SaveBarProps, 'isDirty' | 'isSaving'>): SaveState => {
  if (isSaving) return 'saving';
  return isDirty ? 'dirty' : 'saved';
};

/**
 * Sticky Cancel / Save bar that flags unsaved changes until they are saved.
 */
export const SaveBar = ({ isDirty, isSaving, onCancel }: SaveBarProps) => {
  const saveState = saveStateOf({ isDirty, isSaving });
  const changesAreUnsaved = saveState === 'dirty';

  return (
    <section className={styles.saveBar} data-state={saveState} aria-label={SAVE_BAR_COPY.statusLabel}>
      <output>{SAVE_BAR_COPY[saveState]}</output>
      <div className={styles.actions}>
        <Button type="button" variant="outline" onClick={onCancel} disabled={!changesAreUnsaved}>
          {SAVE_BAR_COPY.cancel}
        </Button>
        <Button type="submit" disabled={!changesAreUnsaved}>
          {isSaving && <Loader2 />}
          {SAVE_BAR_COPY.save}
        </Button>
      </div>
    </section>
  );
};
